import columns from '../../../../../../react-table/helpers/columns';
import { sumTotal } from '../../../../../../react-table/helpers/rowTotals';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';

export function getDetailsTabNavOptions(rowInfo) {
  return rowInfo && rowInfo.row ? {
    reportId: ReportDefinitions.PREDES_PLANNED_TRANSPORT_ANOMALIES_ORIGIN_DETAILS.id,
    mainReportId: ReportDefinitions.PREDES_PLANNED_TRANSPORT_ANOMALIES_ORIGIN_SUMMARY.id,
    requestParams: {
      impcFrom: rowInfo.row['originImpc.code'],
    },
    selectionCriteriaOptions: {
      includeSelectionCriteria: true,
    },
  } : {};
}

export default (data) => {
  const {
    TextColumn,
    NonZeroNumberColumn,
    NavigationColumn,
  } = columns(data);

  return [
    {
      Header: 'Origin IMPC',
      columns: [
        new TextColumn('Operator', 'originImpc.operator'),
        new TextColumn('Code', 'originImpc.code').withTotalHeader('Total'),
      ],
    },
    {
      Header: '',
      columns: [
        new NavigationColumn(new NonZeroNumberColumn('Despatches', 'despatches').withTotalHeader(sumTotal), getDetailsTabNavOptions),
      ],
    },
    {
      Header: 'Planned departure - despatch closed (hours)',
      columns: [
        new NavigationColumn(new NonZeroNumberColumn('<= 0', 'predesVsPlanning.withinPlan').withTotalHeader(sumTotal), getDetailsTabNavOptions),
        new NavigationColumn(new NonZeroNumberColumn('<= 2', 'predesVsPlanning.missedBy2h').withTotalHeader(sumTotal), getDetailsTabNavOptions),
        new NavigationColumn(new NonZeroNumberColumn('> 2 <= 6', 'predesVsPlanning.missedBy2to6h').withTotalHeader(sumTotal), getDetailsTabNavOptions),
        new NavigationColumn(new NonZeroNumberColumn('> 6 <= 24', 'predesVsPlanning.missedBy6to24h').withTotalHeader(sumTotal), getDetailsTabNavOptions),
        new NavigationColumn(new NonZeroNumberColumn('> 24 <= 48', 'predesVsPlanning.missedBy24to48h').withTotalHeader(sumTotal), getDetailsTabNavOptions),
        new NavigationColumn(new NonZeroNumberColumn('> 48 <= 72', 'predesVsPlanning.missedBy48to72h').withTotalHeader(sumTotal), getDetailsTabNavOptions),
        new NavigationColumn(new NonZeroNumberColumn('> 72', 'predesVsPlanning.missedByMoreThan72h').withTotalHeader(sumTotal), getDetailsTabNavOptions),
        new NavigationColumn(new NonZeroNumberColumn('No departure date', 'predesVsPlanning.noDepartureDate').withTotalHeader(sumTotal), getDetailsTabNavOptions),
      ],
    },
  ];
};
